<div class="responsive-table table-mobile-cart" i18n-data-th="@@AddToCart" data-th="Количество">
  <div class="cart-table">
    <div class="cart-table__top">
      <div class="cart-table__block-count">

        <div class="cart-table__count">
          <button class="down-arrow__click pointer" (click)="decrease()">
            <tui-icon icon="minus"/>
          </button>

          <input nbInput [formControl]="inputFormControl" (keydown)="onKeyDown($event)" (input)="manualChange()" digitOnly [class.withUnit]="product.unitHeader"/>
          <button class="up-arrow__click pointer" (click)="increase()">
            <tui-icon icon="plus"/>
          </button>


        </div>
        @if (product.unitHeader) {
          <div class="cart-table__pieces">
            <p>{{ product.unitHeader }}</p>
          </div>
        }
      </div>
      <div class="cart-table__add">
        <button nbButton status="primary" (click)="addToSpecification()">
          <span class="cart-table__mobile" i18n="@@AddToSpecification">Добавить в спецификацию</span> <img src="/assets/images/catalog/clip.svg" alt="">
        </button>
      </div>
    </div>
    @if (multiplicityOrder > 1) {
      <div class="packaging">{{ multiplicityHeader | lowercase }} {{ multiplicityOrder }} {{ product.unitHeader }}</div>
    }
  </div>
</div>
